module.exports = __webpack_public_path__ + "assets/img/kv-6c2575b4.jpg";